<template>
  <path d="M10.0001 1.66666C14.6001 1.66666 18.3334 5.39999 18.3334 9.99999C18.3334 14.6 14.6001 18.3333 10.0001 18.3333C5.40008 18.3333 1.66675 14.6 1.66675 9.99999C1.66675 5.39999 5.40008 1.66666 10.0001 1.66666ZM10.0001 16.6667C13.6834 16.6667 16.6667 13.6833 16.6667 9.99999C16.6667 6.31666 13.6834 3.33332 10.0001 3.33332C6.31675 3.33332 3.33341 6.31666 3.33341 9.99999C3.33341 13.6833 6.31675 16.6667 10.0001 16.6667ZM10.0001 9.16666H13.3334V10.8333H10.0001V13.3333L6.66675 9.99999L10.0001 6.66666V9.16666Z"/>
</template>

<script>
export default {
  name: "IconArrowLeftCircleLine"
}
</script>

<style scoped>

</style>